export const searchBarFilters = {
  open: 'Open',
  won: 'Won',
  lost: 'Lost',
};
